import Container from './SubmitFormBanner.container';
import SubmitFormBanner from './SubmitFormBanner';

export default Container(SubmitFormBanner);
